import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal, Spin, message } from 'antd';
import UpdateView from './UpdateView';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import format from '../../../shared/format';
import { getMatchOption } from '../../../shared/selectFn';

const typeInConfig = {
    add: {
        title: '添加历史合同',
        message: '新建成功',
        url: API_URL.investigation.addInvestigationJdeContractHistory,
    },
    edit: {
        title: '修改历史合同',
        message: '修改成功',
        url: API_URL.investigation.updateInvJdeContractHistory,
    }
};

const genConfig = (type) => {
    return {
        ...typeInConfig[type],
        [type]: true
    };
};

function computeAmount(amount, exchangeRate) {
    return (amount || amount === 0) ? (amount * exchangeRate).toFixed(2) : '';
}

function genContractAmount(data, currencyList) {
    const { currencyExchangeRateId, jdeContractAmount, jdeActualExpenseFee, jdeActualFee, jdeContractFee, exchangeRate } = data;
    const { currencyCode } = getMatchOption(currencyList, 'currencyExchangeRateId', currencyExchangeRateId);
    const params = {};

    if (currencyCode === 'CNY') {
        params.initialContractAmount = '';
        params.initialActualExpenseFee = '';
        params.initialActualFee = '';
        params.initialContractFee = '';
    } else {
        params.initialContractAmount = jdeContractAmount;
        params.initialActualExpenseFee = jdeActualExpenseFee;
        params.initialActualFee = jdeActualFee;
        params.initialContractFee = jdeContractFee;

        params.jdeContractAmount = computeAmount(jdeContractAmount, exchangeRate);
        params.jdeActualExpenseFee = computeAmount(jdeActualExpenseFee, exchangeRate);
        params.jdeActualFee = computeAmount(jdeActualFee, exchangeRate);
        params.jdeContractFee = computeAmount(jdeContractFee, exchangeRate);
    }

    return params;
}

class Update extends PureComponent {
    static contextTypes = {
        levelList: PropTypes.array,
        stageList: PropTypes.array,
        testeeTypeList: PropTypes.array,
        typeList: PropTypes.array,
        businessList: PropTypes.array,
        signingUnit: PropTypes.array,
        contractTypeList: PropTypes.array,
        currencyList: PropTypes.array,
    }

    state = {
        visible: false,
        loading: false,
        data: {},
        byStageList: [],
    }

    record = {};
    
    config = {};

    show = (record, type) => {
        this.record = record;
        this.config = genConfig(type);

        let data;
        if (this.config.add) {
            const { currencyList } = this.context;
            const { currencyExchangeRateId, exchangeRate } = getMatchOption(currencyList, 'currencyCode', 'CNY');
            data = {
                currencyExchangeRateId,
                exchangeRate,
            };
        } else {
            const {
                pmEmployeeCode, pmUserCompellation, bdEmployeeCode, bdUserCompellation,
                baEmployeeCode, baUserCompellation, ...rest
            } = record;
            data = {
                ...rest,
                pmUserName: format('joint', pmUserCompellation, pmEmployeeCode),
                bdUserName: format('joint', bdUserCompellation, bdEmployeeCode),
                baUserName: format('joint', baUserCompellation, baEmployeeCode),
            };
        }

        this.setState({
            data,
            visible: true
        }, () => {
            if (this.config.edit) {
                this.loadInvestigationByStageList();
            }
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadInvestigationByStageList = () => {
        const { data: { investigationMedicineType } } = this.state;
        if (!investigationMedicineType) {
            this.setState({ byStageList: [] });
        } else {
            const options = {
                method: 'POST',
                url: API_URL.common.queryInvestigationByStageByMedicine,
                data: { investigationMedicineType },
                dataType: 'json',
                doneResult: data => {
                    this.setState({ byStageList: data.data });
                }
            };
            $.sendRequest(options);
        }
    }

    handleChange = (value, key) => {
        const { data } = this.state;
        
        switch (key) {
            case 'investigationStageIds': {
                const { levelList, stageList } = this.context;
                let newValue = (value || []).slice();
                if (newValue.length >= 2) {
                    let lastValue;
                    const { groupId: fg } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                    const { groupId: lg } = getMatchOption(stageList, 'typeConfigureId', (lastValue = newValue.slice(-1))[0]);
                    if (fg !== lg) {
                        newValue = lastValue;
                    }
                }

                const { typeValue } = getMatchOption(stageList, 'typeConfigureId', newValue[0]);
                if (typeValue === '治疗结束随访期' || typeValue === '项目暂停') {
                    const { levelId } = data;
                    const { typeValue: level } = getMatchOption(levelList, 'typeConfigureId', levelId);
                    if (level && level !== 'C') {
                        data.levelId = levelId + 1;
                    }
                }
                data.investigationStageIds = (newValue || []).join(',');
                break;
            }
            case 'disease': {
                const { value: id, text: name, investigationAreaId, investigationAreaName } = value;
                data.diseaseId = id;
                data.diseaseName = name ? name.replace(/^(NA)\(.+\)$/, '$1') : undefined;
                data.investigationAreaId = investigationAreaId;
                data.investigationAreaName = investigationAreaName;
                break;
            }
            case 'investigationMedicineType': {
                data.investigationMedicineType = value;
                data.investigationByStageIds = undefined;
                this.setState({ data }, () => {
                    this.loadInvestigationByStageList(value);
                });
                return;
            }
            case 'investigationByStageIds': {
                const { byStageList } = this.state;
                const { isMultipleChoice, investigationByStageId } = getMatchOption(byStageList, 'investigationByStageId', (value || []).slice(-1));
                data.investigationByStageIds = (isMultipleChoice == 1 ? value : investigationByStageId ? [String(investigationByStageId)] : []).join(',');
                break;
            }
            case 'investigationSponsor':
            case 'pmUser':
            case 'bdUser':
            case 'baUser': {
                const { value: id, text: name } = value;
                data[`${key}Id`] = id;
                data[`${key}Name`] = name;
                break;
            }
            case 'lineOfBusinessId': {
                const { businessList } = this.context;
                const { categoryCodeName13 } = getMatchOption(businessList, 'typeConfigureId', value);
                data.lineOfBusinessId = value;
                data.secondLineIds = undefined;
                data.categoryCodeName13 = categoryCodeName13;
                break;
            }
            case 'secondLineIds': {
                data.secondLineIds = value ? value.toString() : '';
                break;
            }
            case 'signingUnit': {
                const { signingUnit } = this.context;
                const belongingToUnit = getMatchOption(signingUnit, 'unitOfSigningId', value).belongings || [];

                if (value && !belongingToUnit.length) {
                    message.warning('收入归属单位不能为空，请联系后台管理员为合同签署单位设置收入归属单位');
                }

                const [{ unitOfBelongingId } = {}] = belongingToUnit;
                data.signingUnit = value;
                data.belongingToUnit = unitOfBelongingId;
                break;
            }
            case 'customerCompany': {
                const { value: id, text: name, customerCompanyCode } = value;
                data.customerCompanyId = id;
                data.customerCompanyName = name;
                data.customerJdeCode = customerCompanyCode;
                break;
            }
            case 'currencyExchangeRateId': {
                const { currencyList } = this.context;
                const { currencyCode, exchangeRate } = getMatchOption(currencyList, 'currencyExchangeRateId', value);
                data.currencyExchangeRateId = value;
                data.exchangeRate = currencyCode === 'CNY' ? exchangeRate : undefined;
                break;
            }
            default:
                data[key] = value;
                break;
        }

        this.setState({ data: {...data} });
    }

    getContent = () => {
        const {
            stageList, testeeTypeList, typeList, businessList, signingUnit,
            contractTypeList, currencyList
        } = this.context;
        const { data, byStageList } = this.state;
        const params = {
            stageList,
            byStageList,
            testeeTypeList,
            typeList,
            businessList,
            signingUnit,
            contractTypeList,
            currencyList,
        };
        return (
            <UpdateView
                data={data}
                config={this.config}
                {...params}
                onChange={this.handleChange}
            />
        );
    }

    confirm = () => {
        const { currencyList } = this.context;
        const { data } = this.state;

        if (!data.mainInvestigationJdeContractCode) {
            return message.warning('请输入JDE主项目号!');
        }
        if (!data.investigationName) {
            return message.warning('请输入项目简称!');
        }
        if (!data.investigationSponsorId) {
            return message.warning('请选择申办方!');
        }
        if (!data.investigationJdeContractCode) {
            return message.warning('请输入JDE项目号!');
        }
        if (!data.investigationJdeContractNumber) {
            return message.warning('请输入合同编号!');
        } else if (!/^C\d{5}$/.test(data.investigationJdeContractNumber)) {
            return message.warning('输入的合同编号格式不正确，格式：C+5位数字!');
        }
        if (!data.lineOfBusinessId) {
            return message.warning('请选择业务线!');
        }
        if (!data.signingUnit) {
            return message.warning('请选择合同签署单位!');
        }
        if (!data.belongingToUnit) {
            return message.warning('请选择收入归属单位!');
        }
        if (!data.customerCompanyId) {
            return message.warning('请选择客户全名!');
        }
        if (!data.contractTypeId) {
            return message.warning('请选择计收入确认方式!');
        }
        if (!data.invoiceRate) {
            return message.warning('请输入发票税率!');
        }
        if (!data.investigationJdeContractIsSigned) {
            return message.warning('请选择合同是否签署完成!');
        }
        if (!data.investigationJdeContractIsSpecifiesAmount) {
            return message.warning('请选择合同中是否明标合同金额!');
        }
        if (!data.currencyExchangeRateId) {
            return message.warning('请选择币种!');
        }
        if (!data.exchangeRate && data.exchangeRate !== 0) {
            return message.warning('请输入汇率!');
        }
        if (!data.startTime) {
            return message.warning('请选择合同开始时间!');
        }
        if (!data.jdeContractAmount && data.jdeContractAmount !== 0) {
            return message.warning('请输入合同额含税!');
        }
        if (!data.jdeContractFee && data.jdeContractFee !== 0) {
            return message.warning('请输入合同额税费!');
        }
        if (!data.endTime) {
            return message.warning('请选择合同结束时间!');
        }
        if (!data.contractNature) {
            return message.warning('请选择合同性质!');
        }

        const params = genContractAmount(data, currencyList);
        
        this.setState({ loading: true });
        $.sendRequest({
            method: 'POST',
            url: this.config.url,
            data: {
                ...data,
                ...params,
            },
            doneResult: () => {
                message.success(this.config.message);
                this.setState({
                    loading: false,
                    visible: false,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        });
    }

    render() {
        const { visible, loading } = this.state;
        return (
            <Modal
                title={this.config.title}
                visible={visible}
                onOk={this.confirm}
                onCancel={this.hide}
                width="1000px"
                maskClosable={false}
                bodyStyle={{ maxHeight: 500 }}
                confirmLoading={loading}
            >
                <Spin spinning={loading}>
                    {this.getContent()}
                </Spin>
            </Modal>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/Update.js